
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import {TaksitHesapAyarEntity} from "@/entity/TaksitHesapAyarEntity";
import TaksitDuzenleForm from "@/components/anakart/taksitlendirme/TaksitDuzenleForm.vue";
import OdemeTaahhuduTaslak from "@/components/OdemeTaahhuduTaslak.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {TaksitEntity} from "@/entity/TaksitEntity";

@Component({
  components: {DeleteDialog, FormDialog, OdemeTaahhuduTaslak, TaksitDuzenleForm, Tutar, Dates}
})
export default class OzelTaksitlendirme extends Mixins(ObjectInputMixin) {
  @Prop() esasBorc!: number;
  @Prop({default: false}) disabledHesaplamaButton!: boolean;
  @Prop({default: 0}) existingLength!: number;
  @Prop({default: false}) canContinue!: boolean;

  localValue!: TaksitHesapAyarEntity;
  isError: boolean = false;
  hataMesaji = "Hesaplamada hata oluştu.";
  periyodlar = [
    {text: "Ay", value: "ay"},
    {text: "Hafta", value: "hafta"}
  ]
  taksitler:any=[]
  sayisinaGoreHesapla:number=0
  tutarinaGoreHesapla:number=1

  mounted() {
    this.localValue.hesaplansin_mi = false;
    // Sıfırlama sonrası alanları tekrar doldurmak için defaultları ayarla
    if(this.localValue.taksit_periyodu==null){
      this.localValue.taksit_periyodu='ay'
    }
    if(this.localValue.taksit_periyod_sayisi==null){
      this.localValue.taksit_periyod_sayisi=1
    }
  }
  get taksitTarihi(){
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const taksitBaslangicTarihi = tomorrow.toISOString().slice(0, 10);
    return taksitBaslangicTarihi
  }
  clickSayisinaGore(){
    this.$emit('changeTabs',this.sayisinaGoreHesapla)
  }
  clickTutarinaGore(){
    this.$emit('changeTabs',this.tutarinaGoreHesapla)
  }

  // faiz switch kaldırıldı


  /*inputKontrol() {
    if (!this.localValue.taksit_baslangic_tarihi) {
      this.isError = true;
      this.hataMesaji = "Başlangıç tarihini giriniz.";
      return false;
    }
    if (!this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarını giriniz.";
      return false;
    }
    if (this.localValue.taksit_tutari && this.esasBorc < this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarı toplam borçtan büyük olamaz.";
      return false;
    }else if(new Date(this.localValue.taksit_baslangic_tarihi)<new Date(this.taksitTarihi)){
      this.isError = true;
      this.hataMesaji = "Taksit Başlangıç tarihini doğru giriniz";
    }
    this.isError = false;
    return true;
  }*/

  load() {
    if (!this.localValue.taksit_baslangic_tarihi) {
      this.isError = true;
      this.hataMesaji = "Başlangıç tarihini giriniz.";
      return false;
    }else if (!this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarını giriniz.";
      return false;
    }else if (!this.localValue.taksit_sayisi || Number(this.localValue.taksit_sayisi) <= 0) {
      this.isError = true;
      this.hataMesaji = "Taksit sayısını giriniz.";
      return false;
    }else if (this.localValue.taksit_tutari && this.esasBorc < this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarı kalan tutardan büyük olamaz.";
      return false;
    }else if(new Date(this.localValue.taksit_baslangic_tarihi)<new Date(this.taksitTarihi)){
      this.isError = true;
      this.hataMesaji = "Taksit Başlangıç tarihini doğru giriniz";
    }else{
      // İstek atma: yerelde N adet taksit oluştur (kullanıcının girdiği tutar ve sayısı)
      this.isError = false;
      const startDate = new Date(this.localValue.taksit_baslangic_tarihi as any);
      const perCount = Number(this.localValue.taksit_periyod_sayisi) || 1;
      const isMonth = (this.localValue.taksit_periyodu||'ay') === 'ay';

      const createItem = (date: Date, amount: number, indexValue: number) => ({
        index: indexValue,
        tarih: date.toISOString().slice(0,10),
        tutar: amount,
        faiz_isleyen_gun: 0,
        isleyen_faiz: 0,
        toplam_faiz: 0,
        kalan_ana_para: 0,
        kalan_faiz: 0,
        kalan_borc: 0
      });
      const amount = Number(this.localValue.taksit_tutari) || 0;
      const count = Number(this.localValue.taksit_sayisi) || 1;
      const taksitler: any[] = [];
      const startIndex = Number(this.existingLength) || 0;
      for(let i=0;i<count;i++){
        const d = new Date(startDate);
        if(isMonth) d.setMonth(d.getMonth() + (i*perCount));
        else d.setDate(d.getDate() + (i*7*perCount));
        taksitler.push(createItem(d, amount, startIndex + i + 1));
      }

      this.$emit('ozelTaksit', taksitler);
    }

  }

  /*taksitEkle() {
    if (this.inputKontrol()) {
      this.localValue.hesaplansin_mi = false;
      this.input();
      this.$emit('success');
    }
  }*/
  @Prop() loading!: boolean;
  @Prop() takip!: TakipEntity;

  @Ref("odemeTaahhuduTaslak")
  readonly odemeTaahhuduTaslak!: OdemeTaahhuduTaslak;

  dialog = false;
  printMode = false;
  multipleDelete = false;
  isKartNoVisible: boolean = true;
  secilenTaksitler = [];
  headers = [
    {text: "Tarih", value: "taksit_baslangic_tarihi"},
    {text: "Taksit Tutarı", value: "taksit_tutari", sortable: false},
    {text: "Faiz İşleyen Gün", value: "faiz_isleyen_gun", sortable: false},
    {text: "İşleyen Faiz", value: "isleyen_faiz", sortable: false},
    {text: "Toplam Faiz", value: "toplam_faiz", sortable: false},
    {text: "Kalan Ana Para", value: "kalan_ana_para", sortable: false},
    {text: "Kalan Faiz", value: "kalan_faiz", sortable: false},
    {text: "Kalan Borc", value: "kalan_borc", sortable: false},
    {text: "İşlemler", value: "actions", width: 100, align: 'center', sortable: false}
  ]

}
